// extracted by mini-css-extract-plugin
export default {"autoLogin":"index_autoLogin_XDMi9 clearfix","checkBox":"index_checkBox_IrHmb","txt":"index_txt_2G-sB","register":"index_register_sdVmn"};